import React from "react";

import { useTranslation } from "react-i18next";

import { FormTextInput } from "@/uiKit/molecules/form/FormTextInput.tsx";

export type PatientEmailFormFieldProps = {
  name?: string;
  labelType?: "left" | "default";
  className?: string;
};

export const PatientEmailFormField: React.FC<PatientEmailFormFieldProps> = ({
  name = "email",
  labelType = "default",
  className,
}) => {
  const { t } = useTranslation();
  return (
    <FormTextInput
      id="patient-email-form-field"
      name={name}
      label={t("form.email.label")}
      autoComplete="email"
      reserveErrorSpace
      className={className}
      labelType={labelType}
    />
  );
};
